import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ResilienceMechanism } from './types';
export class MetricsCollector {
  constructor() {
    _defineProperty(this, "itemsDiscardedByRetry", 0);

    _defineProperty(this, "eventCount", 0);

    _defineProperty(this, "itemsDiscardedByOverflow", 0);

    _defineProperty(this, "resilienceMechanism", ResilienceMechanism.LOCALSTORAGE);

    _defineProperty(this, "duplicateEventCount", 0);

    _defineProperty(this, "localstorageDuplicateCount", 0);

    _defineProperty(this, "localstorageNumberOfQueuesPurged", 0);

    _defineProperty(this, "localstorageNumberOfFullReclaims", 0);

    _defineProperty(this, "localstorageNumberOfPartialReclaims", 0);

    _defineProperty(this, "localstorageNumberOfFailedReclaims", 0);
  }

  addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
    this.itemsDiscardedByRetry += numberOfDeletedEvents;
  }

  addToEventCount() {
    this.eventCount++;
  }

  addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
    this.itemsDiscardedByOverflow += numberOfDeletedEvents;
  }

  setResilienceMechanism(mechanism) {
    this.resilienceMechanism = mechanism;
  }
  /* <Localstorage specific> */


  addToDuplicateEventCounter() {
    this.duplicateEventCount++;
  }

  addToLocalstorageDuplicateCount() {
    this.localstorageDuplicateCount++;
  }

  addToReclaimMetrics(reclaimMetrics) {
    this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
    this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
    this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
  }

  addToPurgedQueuesMetrics(numberOfQueuesPurged) {
    this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
  }
  /* </Localstorage specific> */


  subtractFromMetrics(sentMetrics) {
    this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
    this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
    this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow); // Localstorage specific

    this.duplicateEventCount = this.subtractFromCount(this.duplicateEventCount, sentMetrics.duplicateEventCount);
    this.localstorageDuplicateCount = this.subtractFromCount(this.localstorageDuplicateCount, sentMetrics.localstorageDuplicateCount);
    this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
    this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
    this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
    this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
  }

  subtractFromCount(count, subtract) {
    return Math.max(count - (subtract || 0), 0);
  }

  getMetricsPayload() {
    return {
      itemsDiscardedByRetry: this.itemsDiscardedByRetry,
      eventCount: this.eventCount,
      itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
      resilienceMechanism: this.resilienceMechanism,
      // Localstorage specific
      duplicateEventCount: this.duplicateEventCount,
      localstorageDuplicateCount: this.localstorageDuplicateCount,
      localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
      fullReclaims: this.localstorageNumberOfFullReclaims,
      partialReclaims: this.localstorageNumberOfPartialReclaims,
      failedReclaims: this.localstorageNumberOfFailedReclaims
    };
  }

}
let cachedMetricsClient = null;
export default (() => {
  if (!cachedMetricsClient) {
    cachedMetricsClient = new MetricsCollector();
  }

  return cachedMetricsClient;
});